import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  {
    q: "Wann findet das erste Event statt?",
    a: "Wir arbeiten gerade an unserem ersten Event. Alle Infos dazu kommen in Kürze zuerst auf Instagram — folgt @housegemachtt und verpasst nichts.",
  },
  {
    q: "Wo finden die Events statt?",
    a: "Immer die heißesten und besten Locations in Köln — vom Rooftop bis in den Keller.",
  },
  {
    q: "Was läuft musikalisch bei euch?",
    a: "DJs von vor Ort und handverlesene Sets, die knallen — von deep bis treibend, aber immer House. Kein Firlefanz, nur Musik, die den Floor trägt.",
  },
  {
    q: "Wie komme ich an Tickets?",
    a: (
      <>
        Tickets gibt's direkt an der Abendkasse — kommt einfach vorbei. Alle Infos dazu gibt's auf
        Instagram:{" "}
        <a
          href="https://www.instagram.com/housegemachtt"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="faq-instagram-link"
          className="text-[#f4f4f2] underline underline-offset-4 transition-colors duration-200 hover:text-[#a8a8a4]"
        >
          @housegemachtt
        </a>
      </>
    ),
  },
  {
    q: "Kann ich bei euch mitmachen?",
    a: "Klar — ob DJ-Set, Visuals, Location-Tipp oder einfach gute Energie: Schreibt uns per DM auf Instagram.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-b-2 border-[#f4f4f2] px-6 py-16 md:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-[920px]">
        <Reveal>
          <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.22em] md:text-xs">
            Gut zu wissen
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display mt-5 text-[clamp(2rem,7vw,4rem)] uppercase leading-none tracking-tight">
            FAQ
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-10">
          <div className="border-t-2 border-[#f4f4f2]">
            {ITEMS.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b-2 border-[#f4f4f2]" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-trigger-${i}`}
                    aria-expanded={isOpen}
                    className="group flex w-full items-center justify-between gap-6 px-1 py-6 text-left transition-colors duration-200 hover:bg-[#f4f4f2]/5 md:px-4"
                  >
                    <span className="flex items-baseline gap-4 md:gap-6">
                      <span className="font-mono2 text-[11px] font-bold tracking-[0.2em] text-[#a8a8a4]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="text-base font-semibold md:text-xl">{item.q}</span>
                    </span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                      className="shrink-0"
                    >
                      <Plus className="h-5 w-5" strokeWidth={2.5} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          className="max-w-[620px] px-1 pb-7 pl-8 text-sm leading-relaxed text-[#a8a8a4] md:px-4 md:pl-12 md:text-base"
                          data-testid={`faq-answer-${i}`}
                        >
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
